
import { defineComponent } from "vue";
import { mapGetters } from "vuex";

export default defineComponent({
  name: "VenuesDataTable",
  props: {
    tableData: Array,
    activeTab: String
  },
  methods: {
    openDeleteModal(venue) {
      this.$emit("openDeleteModal", venue);
    },
    openEditModal(venue) {
      this.$emit("openEditModal", venue);
    }
  }
});
